import { Control, Controller, Path, UseControllerProps } from 'react-hook-form';
import { OutlinedTextFieldProps, TextField } from '@mui/material';
import InputMask from 'react-input-mask';

interface PropTypes<T> extends Omit<OutlinedTextFieldProps, 'variant'> {
  name: Path<T>;
  control: Control<any>;
  defaultValue: UseControllerProps['defaultValue'];
  rules?: UseControllerProps['rules'];
  mask: string;
}

export const ControlledMaskedField = <T extends unknown>({
  name,
  control,
  defaultValue,
  rules,
  mask,
  ...props
}: PropTypes<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field: { onChange, onBlur, value, ...field }, fieldState }) => (
      <InputMask mask={mask} onChange={onChange} onBlur={onBlur} value={value}>
        {() => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message || props.helperText}
            type="tel"
            fullWidth
            {...props}
          />
        )}
      </InputMask>
    )}
  />
);
